import { useMonaco } from "@monaco-editor/react";
import { useEffect } from "react";

import { nativeApis } from "@ea/runner_loader/native.editor.api";
import { CodeType } from "@ea/shared_types/next/ea.enums";
import {
  generateDeclarationForCodeTemplates,
  generateDeclarationForNativeApi,
  generateDeclarationForVariablesGroup,
} from "../MonacoEditorField.helpers";
import { useCodeTemplates, useVariablesGroups } from "./useVariablesGroups";
// eslint-disable-next-line
// @ts-ignore
// import EAFunctions from "@app/generated/eaFunctions.d.ts";

const EAFunctions = "";

export const useExtraLibs = (scriptId: number | undefined, mode: CodeType) => {
  const monacoInstance = useMonaco();
  const variablesGroups = useVariablesGroups(scriptId);
  const codeTemplateWithGroups = useCodeTemplates();

  useEffect(() => {
    if (!monacoInstance || variablesGroups.length === 0 || !scriptId) return;

    const disposables: { dispose: () => void }[] = [];

    const declaration = variablesGroups.map(generateDeclarationForVariablesGroup).join("\n");
    disposables.push(
      monacoInstance.languages.typescript.javascriptDefaults.addExtraLib(
        declaration,
        "variableGroups.d.ts",
      ),
    );

    disposables.push(
      monacoInstance.languages.typescript.javascriptDefaults.addExtraLib(
        generateDeclarationForCodeTemplates(codeTemplateWithGroups),
        "codeTemplatesFunctions.d.ts",
      ),
    );

    if (mode === CodeType.NATIVE) {
      Object.values(nativeApis).forEach((api) => {
        const name = `ts:filename/${api.name}.d.ts`;
        monacoInstance.languages.typescript.javascriptDefaults.addExtraLib(
          generateDeclarationForNativeApi(api),
          name,
        );
      });
    }

    // eslint-disable-next-line
    const commonFunctionsArray = (EAFunctions as any).split("\n");
    commonFunctionsArray.splice(commonFunctionsArray.length - 2, 2);
    disposables.push(
      monacoInstance.languages.typescript.javascriptDefaults.addExtraLib(
        commonFunctionsArray.join("\n"),
        "commonFunctions.d.ts",
      ),
    );

    return () => {
      disposables.forEach((d) => d.dispose());
    };
  }, [monacoInstance, variablesGroups, scriptId, codeTemplateWithGroups]);
};
